import bind from 'bind-decorator';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Passenger } from '../../models/passenger';
import { reportError } from '../../telemetry';
import { unreachable } from '../../utils/compose';
import { InjectAPI, InjectApp, InjectHistory, InjectTranslate } from '../app/app';
import { Loader } from '../widgets/loader';
import { PassengerDetailStore, RedeemState } from './passenger-detail-store';

interface PassengerDetailProps {
  readonly passenger: Passenger;
}

type InjectedProps = InjectAPI & InjectApp & InjectHistory & InjectTranslate;

@observer
class PassengerDetailInner extends React.Component<PassengerDetailProps & InjectedProps> {
  private readonly store: PassengerDetailStore;

  constructor(props: PassengerDetailProps & InjectedProps) {
    super(props);
    this.store = new PassengerDetailStore(props.history, props.app, props.api, props.passenger);
  }

  @bind
  private handleClickRedeemVoucher(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    this.store.handleClickRedeemVoucher().catch(reportError);
  }

  public render() {
    return (
      <li className="passenger-detail">
        <PassengerBlurb className="left" passenger={this.props.passenger}/>
        <div className="right">
          {this.renderRedeemArea()}
        </div>
      </li>
    );
  }

  private renderRedeemArea() {
    switch (this.store.redeemState) {
      case RedeemState.IDLE:
        return this.renderVoucherStatusLink();
      case RedeemState.LOADING:
        return <Loader/>;
      case RedeemState.ERROR:
        return this.renderErrorLink();
      default:
        return unreachable(this.store.redeemState);
    }
  }

  private renderVoucherStatusLink() {
    if (this.props.passenger.voucher)
      return this.renderRedeemed();

    if (this.props.passenger.shouldShowExpiredMessage)
      return this.renderExpired();

    return this.renderRedeemLink();
  }

  private renderRedeemed() {
    const { t } = this.props;

    return [
      <p key="p" className="voucher-redeemed">
        <img className="checkmark" src="/assets/images/checkmark.svg"/>
        {t('common.voucher_redeemed')}
      </p>,
      <Link key="a" to={'/redeem/' + this.props.passenger.id.toString()}>{t('flight_info.send_again')}</Link>,
    ];
  }

  private renderExpired() {
    const { t } = this.props;

    return <Link key="a" to={'/expired/' + this.props.passenger.id.toString()}>{t('flight_info.too_late')}</Link>;
  }

  private renderRedeemLink() {
    const { t } = this.props;

    return <a href="#" onClick={this.handleClickRedeemVoucher}>{t('flight_info.redeem_voucher')}</a>;
  }

  private renderErrorLink() {
    const { t } = this.props;

    return [
      <a key="a" href="#" onClick={this.handleClickRedeemVoucher}>{t('flight_info.redeem_voucher')}</a>,
      <p key="p" className="red">{t('flight_info.redeem_error')}</p>,
    ];
  }
}

interface PassengerBlurbProps {
  readonly className?: string;
  readonly passenger: Passenger;
}

function PassengerBlurbC(props: PassengerBlurbProps & InjectTranslate) {
  const { className, passenger, t } = props;
  const ageCategory = (passenger.ageCategory === 'ADULT') ? t('common.adult') : t('common.child');
  return (
    <div className={className}>
      <h3>{passenger.firstName} {passenger.lastName}</h3>
      <p>
        {/* TODO: translate ageCategory */}
        <span className="age-category">{ageCategory}</span>
        {passenger.isPrimaryContact && ' - ' + t('common.contact')}
      </p>
    </div>
  );
}

export const PassengerBlurb: React.StatelessComponent<PassengerBlurbProps> = inject('t')(PassengerBlurbC);

export const PassengerDetail =
  withRouter(inject('api', 'app', 't')(PassengerDetailInner)) as React.ComponentClass<PassengerDetailProps>;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/segment/passenger-detail.tsx